module.exports = __webpack_public_path__ + "public/img/card.0e33b9e5.png";